const LoanCardReportActionTypes = {
	/****************  GET PARTICULAR MEMBER LOAN CARD START ********************** */
	GET_MEMBER_LOAN_CARD_START: 'GET_MEMBER_LOAN_CARD_START',
	GET_MEMBER_LOAN_CARD_SUCCESS: 'GET_MEMBER_LOAN_CARD_SUCCESS',
	GET_MEMBER_LOAN_CARD_FAILURE: 'GET_MEMBER_LOAN_CARD_FAILURE',
	GET_MEMBER_LOAN_CARD_RESPONSE_RESET: 'GET_MEMBER_LOAN_CARD_RESPONSE_RESET',
	GET_MEMBER_LOAN_CARD_RESPONSE_CHANGED: 'GET_MEMBER_LOAN_CARD_RESPONSE_CHANGED',
	/****************  GET PARTICULAR MEMBER LOAN CARD END ********************** */
};
export default LoanCardReportActionTypes;
